import { useState, useEffect } from 'react';
import { downloadFiles, getCustomerLeadgerData, getPreviousDivWiseLedgerData, fetchProfitCenters } from '../../Service/ApiService';
import { useNavigate } from '../../../node_modules/react-router-dom/dist/index';
import { showSuccessAlert } from 'utils/SuccessMessage';
const LedgerPreviousDivWiseController = (initialState, validate) => {
  const [formData, setFormData] = useState(initialState);
  const [customeroptions, setCustomerOptions] = useState([]);
  const [ledgerData, setLedgerData] = useState([]);
  const [cloading, setcLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const user = JSON.parse(localStorage.getItem('user'));
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));
  const [searchText, setSearchText] = useState('');
  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const [profitCenters, setProfitCenters] = useState([]);
  const [selectedProfitCenter, setSelectedProfitCenter] = useState('');
  const [profitCentersParam, setProfitCentersParam] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    if (user.profitCenter != null) {
      getProfitCenters(user.profitCenter);
    }
  }, []);

  useEffect(() => {
    getCustomer();
  }, [searchText]);


  useEffect(() => {
    if (formData.customer == null || formData.customer == '') {
      fetchLedgerData(user.userCode, confvalue.confvertical, selectedProfitCenter.value);
    }
  }, [formData.customer, selectedProfitCenter]);

  // Show ledger details for garment user
  useEffect(() => {
    if (user.userVerticalId == "Garment") {
      fetchLedgerData(user.userCode, confvalue.confvertical, user.profitCenter);
    }
  }, []);


  useEffect(() => {
    const totalDebit = ledgerData.reduce(
      (sum, item) => sum + parseFloat(item.debit || 0),
      0
    );
  
    const totalCredit = ledgerData.reduce(
      (sum, item) => sum + parseFloat(item.credit || 0),
      0
    );
  
    setTotalDebit(Number(totalDebit.toFixed(2)));
    setTotalCredit(Number(totalCredit.toFixed(2)));
  
  }, [ledgerData]);

  const getProfitCenters = async (profitCentersParam) => {
    try {
      setcLoading(true);
      const response = await fetchProfitCenters(profitCentersParam);
      setLedgerData([]); // Clear previous ledger data

      if (response && response.success) {
        // Map API response into { value, label } format for react-select
        const mappedProfitCenters = response.data.map(item => ({
          value: item.profitCenter,
          label: `${item.profitCenterName} - ${item.profitCenter}`
        }));
        setProfitCenters(mappedProfitCenters);

        // const allProfitCentersValues = mappedProfitCenters.map(item => item.value).join(',');
        setSelectedProfitCenter(mappedProfitCenters[0])
        setProfitCentersParam(mappedProfitCenters[0].value);

        fetchLedgerData(user.userCode, confvalue.confvertical, mappedProfitCenters[0].value);

        // If only one profit center, auto-select it
        if (mappedProfitCenters.length === 1) {
          setSelectedProfitCenter(mappedProfitCenters[0]);
          setProfitCentersParam(mappedProfitCenters[0]);
        }
      }

      setcLoading(false);
    } catch (error) {
      console.error('Error fetching profit centers:', error);
      setcLoading(false);
    }
  };

  const handleInputChange = (inputValue) => {
    setSearchText(inputValue);
  };

  const handleViewClick = (rowData) => {
    const ledgerData = {
      partyCode: rowData.partyCode,
      month: rowData.month,
      year: rowData.year,
      opening: rowData.opening
    };

    localStorage.setItem('previousDivWiseLedgerData', JSON.stringify(ledgerData));

    if (user.userVerticalId == "Garment") {
      navigate('/previousDivWiseLedgerDetails', { state: { profitCenter: user.profitCenter } });
    }
    else {
      navigate('/previousDivWiseLedgerDetails', { state: { profitCenter: selectedProfitCenter.value } });
    }
  };

  const handleDownloadAll = async () => {
    setcLoading(true);

    let param = '';

    if (user.userVerticalId == "Garment") {
      param = `userCode=${user.userCode}&partyCode=${user.userCode}&userVertical=${confvalue.confvertical}&profitCenter=${user.profitCenter}&isSFA=${user.isSFA}`;
    }
    else{
      param = `userCode=${user.userCode}&partyCode=${formData.customer.value || user.userCode}&userVertical=${confvalue.confvertical}&profitCenter=${selectedProfitCenter.value}&isSFA=${user.isSFA}`;
    }

    // const param = `partyCode=${formData.customer.value || user.userCode}&userVertical=${confvalue.confvertical}&profitCenter=${user.profitCenter}&isSFA=${user.isSFA}`;
    // const param = `partyCode=${formData.customer.value || user.userCode}&userVertical=${confvalue.confvertical}&profitCenter=${profitCentersParam}&isSFA=${user.isSFA}`;
    // const param = `partyCode=1000`;
    const response = await downloadFiles(param, 'downloadAllPrevDivWiseLedger.php', 'divout.xls');
    if (response == true) {
      showSuccessAlert('File Downloaded Successfully', 'Download Ledger');
    }

    setcLoading(false);
  };

  const handleDownloadClick = async (rowData) => {
    setcLoading(true);
    // const profitCentersArr = ledgerData.profitCenters.join(',');
    console.log(profitCentersParam);
    let param = '';
    if (selectedProfitCenter == null || selectedProfitCenter == '') {
      param = `partyCode=${rowData.partyCode}&month=${rowData.month}&year=${rowData.year}&opening=${rowData.opening}&userVertical=${confvalue.confvertical}&profitCenter=${user.profitCenter}&isSFA=${user.isSFA}`;
    }
    else {
      param = `partyCode=${rowData.partyCode}&month=${rowData.month}&year=${rowData.year}&opening=${rowData.opening}&userVertical=${confvalue.confvertical}&profitCenter=${selectedProfitCenter.value}&isSFA=${user.isSFA}`;
    }

    const response = await downloadFiles(param, 'previousDivWiseLedgerDownload.php', 'ledgerFile.xls');
    if (response == true) {
      showSuccessAlert('Ledger File Downloaded Successfully', 'Download Ledger');
    }

    setcLoading(false);
  };

  const getCustomer = async () => {
    try {
      setcLoading(true);
      // console.log("USER",user);
      const response = await getCustomerLeadgerData(user.userCode, searchText, user.userVerticalId);
      // console.error('Return Response:', response);
      if (response && response.success === 'true') {
        setCustomerOptions([]);
        // comment this functionality for remove duplicate partycode data - 6 June
        // const customerOptions = response.customerList.map((item) => ({
        //   value: item.partyCode.toString(),
        //   label: item.partyName+"-"+item.city+"-"+item.partyCode.toString()
        // }));
        // setCustomerOptions(customerOptions);
        const uniqueCustomerOptions = response.customerList.reduce((uniqueList, currentItem) => {
          // Check if the partyCode of the current item is already present in the unique list
          const existingItem = uniqueList.find((item) => item.value === currentItem.partyCode.toString());

          // If the partyCode is not already in the unique list, add it
          if (!existingItem) {
            uniqueList.push({
              value: currentItem.partyCode.toString(),
              label: currentItem.partyName + '-' + currentItem.city + '-' + currentItem.partyCode.toString()
            });
          }

          return uniqueList;
        }, []);
        setCustomerOptions(uniqueCustomerOptions);
      }
      setcLoading(false);

      // setFormData({
      //   ...formData,
      //   ['customer']: customerString,
      // });
    } catch (error) {
      // console.error('Error during login:', error);
      setcLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      // fetchLedgerData(formData.customer.value, confvalue.confvertical); // Use the new function
      fetchLedgerData(formData.customer.value ?? user.userCode, confvalue.confvertical, selectedProfitCenter.value); // Use the new function
    }
  };

  const fetchLedgerData = async (customerCode, verticalId, profitCenter) => {
    try {
      setcLoading(true);

      // let profitCenter = '';
      if (user.userVerticalId == 'Garment') {
        profitCenter = user.profitCenter;
      }

      const response = await getPreviousDivWiseLedgerData(customerCode, verticalId, profitCenter, user.isSFA);
      setLedgerData([]);
      if (response && response.success === 'true') {
        setLedgerData(response.ledgerList);
      } else {
        setLedgerData([]);
      }
      setcLoading(false);
    } catch (error) {
      console.error('Error fetching ledger data:', error);
      setcLoading(false);
    }
  };
  // const fetchLedgerData = async (customerCode, verticalId, profitCentersParam) => {
  //   try {
  //     setcLoading(true);
  //     // const response = await getPreviousDivWiseLedgerData(customerCode, verticalId, profitCentersParam, user.isSFA);
  //     const response = await getPreviousDivWiseLedgerData(customerCode, verticalId, user.profitCenter, user.isSFA);
  //     setLedgerData([]);
  //     if (response && response.success === 'true') {
  //       setLedgerData(response.ledgerList);
  //     } else {
  //       setLedgerData([]);
  //     }
  //     setcLoading(false);
  //   } catch (error) {
  //     console.error('Error fetching ledger data:', error);
  //     setcLoading(false);
  //   }
  // };

  const handleCustomerChange = (e) => {
    if (e) {
      setFormData({
        ...formData,
        ['customer']: e // Update formData with the selected customer
      });

      setErrors({
        ...errors,
        ['customer']: '' // Clear any existing errors
      });
    } else {
      setFormData({
        ...formData,
        ['customer']: null // Clear the customer field in formData
      });

      setErrors({
        ...errors,
        ['customer']: '' // You can set a validation error or reset it
      });

      setLedgerData([]);
    }
  };

  const handleProfitCenterChange = (value) => {
    if (value) {
      setFormData({
        ...formData,
        ['profitCenters']: value // Update formData with the selected customer
      });

      setErrors({
        ...errors,
        ['profitCenters']: '' // Clear any existing errors
      });
    } else {
      setFormData({
        ...formData,
        ['profitCenters']: null // Clear the customer field in formData
      });

      setErrors({
        ...errors,
        ['profitCenters']: '' // You can set a validation error or reset it
      });

      setLedgerData([]);
    }
    setSelectedProfitCenter(value);
    setProfitCentersParam(value ? value.value : '');
    fetchLedgerData(formData.customer.value ?? user.userCode, confvalue.confvertical ?? "", value.value)
  }


  return {
    profitCenters,
    selectedProfitCenter,
    ledgerData,
    totalDebit,
    totalCredit,
    formData,
    user,
    cloading,
    errors,
    customeroptions,
    handleCustomerChange,
    handleSubmit,
    handleInputChange,
    handleViewClick,
    handleDownloadAll,
    handleDownloadClick,
    handleProfitCenterChange
  };
};

export default LedgerPreviousDivWiseController;
